import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { UserStore } from '../../../../stores/user.store';
import { containsStringValidator } from '../../../../validators/contains-string.validator';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { InputComponent } from '../../../atoms/input/input.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';

@Component({
  selector: 'app-modal-delete-user',
  imports: [ModalHeaderComponent, ButtonComponent, InputComponent],
  templateUrl: './modal-delete-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalDeleteUserComponent {
  readonly control = new FormControl<string>('', [
    Validators.required,
    containsStringValidator('löschen'),
  ]);

  private readonly userStore = inject(UserStore);
  private readonly modalService = inject(ModalService);

  readonly isLoading = computed(() => this.userStore.requestState() === RequestStateEnum.PENDING);

  public deleteUser(): void {
    this.userStore.deleteUser().subscribe({
      next: () => this.modalService.close(),
    });
  }
}
